<template>
  <v-container fluid class="inventoryjournal-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Journal</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Items</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row no-gutters>
                    <p class="text-h5">New Inventory Journal</p>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-form>
                        <v-select
                          class="mb-4"
                          :items=journaltype
                          v-model="new_journal.journaltype"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the journal type">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items=journalsubtype
                          v-model="new_journal.journalsubtype"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Subtype"
                          persistent-hint
                          single-line hint="Please choose the journal subtype">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <v-menu
                          ref="menu_journaldate"
                          v-model="menu_journaldate"
                          :close-on-content-click="false"
                          :return-value.sync="new_journal.journaldate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              v-model="new_journal.journaldate"
                              label="Journal Date"
                              v-bind="attrs"
                              v-bind:value="new_journal.journaldate"
                              v-bind:error="errorindex == 2"
                              v-on="on"
                              single-line hint="Please choose the journal date"
                              persistent-hint
                              >
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="new_journal.journaldate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_journaldate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_journaldate.save(new_journal.journaldate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-select
                          class="mb-4"
                          :items="locations.map(x => {
                            return {text: x.locationname, value: x._id};
                            })"
                          v-model="new_journal.locationid"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Source"
                          persistent-hint
                          single-line hint="Please choose the source location">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-form>
                        <v-text-field
                          class="mb-4"
                          v-model="new_journal.journalname"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Journal Name"
                          persistent-hint
                          single-line hint="Enter the journal name">
                        </v-text-field>
                        <v-textarea
                          v-model="new_journal.journalnote"
                          outlined
                          dense
                          persistent-hint
                          rows=1
                          label="Note"
                          hint="please enter the note"
                        ></v-textarea>
                      </v-form>
                    </v-col>                                     
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/inventoryjournal/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row>
                    <v-col md="6">
                      <p class="text-h5">Items</p>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" lg="6" class="d-flex flex-end justify-md-end overflow-auto" align="right">
                      <v-btn
                        class="button-shadow mr-1"
                        color="success"
                        @click="isAddTransaction=true; add_transaction={};">
                        Add
                      </v-btn>
                      <v-btn
                        class="button-shadow mr-1"
                          to="/inventoryjournal/list"
                          replace
                          color="primary"
                        >
                          Done
                      </v-btn>
                    </v-col>
                    <v-col md="2" align="right">
                    </v-col>
                  </v-row>
                  <v-data-table
                    v-if="isCount==true"
                    sort-by="tranrank"
                    :headers="header_count"
                    :items="transactions"
                    :items-per-page="100"
                    class="elevation-0"
                  >
                    <template v-slot:item.itemimage="{ item }"> 
                      <v-img
                        v-bind:lazy-src="item.itemimage"
                        min-width=50
                        max-width=100
                        v-bind:src="item.itemimage"
                      ></v-img>
                    </template>
                    <template v-slot:item.locationid="{ item }">
                      {{ locations!=null && locations.length>0 ? locations.find(location=>location._id == item.locationid)['locationcode'] : '' }}
                    </template>
                    <template v-slot:item.itemstart="{ item }">
                      {{ item.itemstart.toFixed(2) }}
                    </template>
                    <template v-slot:item.itemadjust="{ item }">
                      {{ item.itemadjust.toFixed(2) }}
                    </template>
                    <template v-slot:item.itemending="{ item }">
                      {{ item.itemending.toFixed(2) }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn icon color="primary" @click="editTransactionDialog(item)">
                        <v-icon>mdi-pencil-outline</v-icon>
                      </v-btn>
                      <v-btn icon color="primary" @click="deleteTransaction(item)">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                  <v-data-table
                    v-else
                    sort-by="tranrank"
                    :headers="header_item"
                    :items="transactions"
                    :items-per-page="100"
                    class="elevation-0"
                  >
                    <template v-slot:item.itemimage="{ item }"> 
                      <v-img
                        v-bind:lazy-src="item.itemimage"
                        min-width=50
                        max-width=100
                        v-bind:src="item.itemimage"
                      ></v-img>
                    </template>
                    <template v-slot:item.locationid="{ item }">
                      <p class="two-line">{{ locations!=null && locations.length>0 ? locations.find(location=>location._id == item.locationid)['locationcode'] : '' }}</p>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn icon color="primary" @click="editTransactionDialog(item)">
                        <v-icon>mdi-pencil-outline</v-icon>
                      </v-btn>
                      <v-btn icon color="primary" @click="deleteTransaction(item)">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                          outlined
                          color="primary"
                          @click="step = 1"
                        >
                          Back
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="insertInventoryJournal()">
                          Save
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isAddTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="new_journal.journalsubtype=='Inventory Transfer' ? data_locations_filter : data_locations"
                    v-model="add_transaction.locationid"
                    v-bind:error="errorindex == 2"
                    dense
                    placeholder="Destination"
                    persistent-hint
                    single-line hint="Destination Location">
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    class="mb-4"
                    :items="brands.filter(brand=>brand.brandtype=='Brand').map(x => {
                      return {text: x.brandname, value: x._id};
                    })"
                    v-model="add_transaction.brandid"
                    v-bind:error="errorindex == 2"
                    dense
                    placeholder="Brand"
                    persistent-hint
                    single-line hint="Brand">
                  </v-select>
                </v-col>
                <v-col cols="12" md="5">
                  <v-select
                    class="mb-4"
                    :items="items.filter(item=>item.brandid == add_transaction.brandid).map(x => {
                      return {text: x.itemname, value: x._id};
                      })"
                    v-model="add_transaction.itemid"
                    v-bind:error="errorindex == 0"
                    v-on:change="onChangeItem"
                    dense
                    placeholder="Item"
                    persistent-hint
                    single-line hint="Item">
                  </v-select>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="add_transaction.increaseQty"
                    class="mb-4"
                    dense
                    placeholder="Increase"
                    persistent-hint
                    type="number"
                    oninput="if(this.value < 0) this.value = 0;"
                    single-line hint="Increase">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    :readonly="new_journal.journalsubtype=='Inventory Transfer'"
                    v-model="add_transaction.decreaseQty"
                    class="mb-4"
                    dense
                    placeholder="Decrease"
                    persistent-hint
                    type="number"
                    oninput="if(this.value < 0) this.value = 0;"
                    single-line hint="Decrease">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="add_transaction.itemcost"
                    class="mb-4"
                    dense
                    placeholder="Cost"
                    persistent-hint
                    single-line hint="Cost">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddTransaction=false; add_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="addTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="locations.filter(i=>i.locationstatus=='Active').map(x => {
                      return {text: x.locationname, value: x._id};
                    })"
                    v-model="edit_transaction.locationid"
                    v-bind:error="errorindex == 2"
                    dense
                    placeholder="Location"
                    persistent-hint
                    single-line hint="Location">
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    class="mb-4"
                    :items="brands.filter(brand=>brand.brandtype=='Brand').map(x => {
                      return {text: x.brandname, value: x._id};
                    })"
                    v-model="edit_transaction.brandid"
                    v-bind:error="errorindex == 2"
                    dense
                    placeholder="Brand"
                    persistent-hint
                    single-line hint="Brand">
                  </v-select>
                </v-col>
                <v-col cols="12" md="5">
                  <v-select
                    class="mb-4"
                    :items="items.filter(item=>item.brandid == edit_transaction.brandid).map(x => {
                      return {text: x.itemname, value: x._id};
                      })"
                    v-model="edit_transaction.itemid"
                    v-bind:error="errorindex == 0"
                    v-on:change="onChangeItemEdit"
                    dense
                    placeholder="Item"
                    persistent-hint
                    single-line hint="Item">
                  </v-select>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="edit_transaction.increaseQty"
                    class="mb-4"
                    dense
                    placeholder="Increase"
                    persistent-hint
                    type="number"
                    oninput="if(this.value < 0) this.value = 0;"
                    single-line hint="Increase">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="edit_transaction.decreaseQty"
                    class="mb-4"
                    dense
                    placeholder="Decrease"
                    persistent-hint
                    type="number"
                    oninput="if(this.value < 0) this.value = 0;"
                    single-line hint="Decrease">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.itemcost"
                    class="mb-4"
                    dense
                    placeholder="Cost"
                    persistent-hint
                    single-line hint="Cost">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';
import { formatStdDate } from '@/util/tools';

export default {
  data () {
    return {
      header_item: [
        { text: 'Image', value: 'itemimage', width: '5%' },
        { text: 'Name', value: 'itemname' },
        { text: 'Location', value: 'locationid', width: '10%' },
        { text: 'Increase', value: 'increaseQty', width: '10%'},
        { text: 'Decrease', value: 'decreaseQty', width: '10%'},
        { text: 'Cost', value: 'itemcost', width: '10%'},
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      header_count: [
        { text: 'Image', value: 'itemimage', width: '5%' },
        { text: 'Name', value: 'itemname' },
        { text: 'Location', value: 'locationid', width: '10%' },
        { text: 'Starting', value: 'itemstart', width: '10%'},
        { text: 'Adjustment', value: 'itemadjust', width: '10%'},
        //{ text: 'Increase', value: 'increaseQty', width: '10%'},
        //{ text: 'Decrease', value: 'decreaseQty', width: '10%'},
        { text: 'Ending', value: 'itemending', width: '10%'},
        { text: 'Cost', value: 'itemcost', width: '10%'},
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      isAddTransaction: false,
      isEditTransaction: false,
      isCount: false,
      transactions: [],
      transactions_count: [],
      brandid: undefined,
      price: undefined,
      step: 1,
      data_inventory: null,
      new_journal: {},
      add_transaction: {},
      edit_transaction: {},
      menu_journaldate: false,
      journaltype: ['Inventory Journal'],
      journalsubtype: ['Inventory Adjustment', 'Inventory Transfer'],
      error: undefined,
      errortag: false,
      errorindex: undefined,
    }
  },
  computed: {
    ...mapState('Brand', ['brands']),
    ...mapState('Item', ['items']),
    ...mapState('Location', ['locations']),
    ...mapState("PriceList", ["pricelists"]),
    ...mapState('Inventory', ['inventory']),
    ...mapState('InventoryJournal', ['isReceiving']),
    data_locations(){
      let result = this.locations.filter(i=>i.locationstatus=='Active').map(x => {
        return {text: x.locationname, value: x._id};
      });
      return result;
    },
    data_locations_filter(){
      let result = this.locations.filter(i=>i.locationstatus=='Active' && i._id!=this.new_journal.locationid).map(x => {
        return {text: x.locationname, value: x._id};
      });
      return result;
    },
  },
  methods: {
    ...mapActions('Brand', ['getBrandsRequest']),
    ...mapActions('Item', ['getItemsRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions("PriceList", ["getPriceListsRequest"]),
    ...mapActions('Inventory', ['findInventoryRequest']),
    ...mapActions('InventoryJournal', ['getInventoryJournals', 'insertInventoryJournalRequest']),
    checkError(){
      if(!this.new_journal.journaltype){
        this.errortags = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.new_journal.journalsubtype){
        this.errortags = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.new_journal.journaldate){
        this.errortags = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.new_journal.locationid){
        this.errortags = true;
        this.errorindex = 4;
        return false;
      }
      if(!this.new_journal.journalname){
        this.errortags = true;
        this.errorindex = 3;
        return false;
      }

      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    addTransaction(){
      if(this.new_journal.journalsubtype=='Inventory Transfer') this.insertTransactionTransfer();
      else this.insertTransaction();
      this.isAddTransaction = false;
      this.clearTransaction();
    },
    clearTransaction(){
      this.add_transaction = {};
      this.edit_transaction = {};
    },
    async insertInventoryJournal() {
      if(this.transactions.length==0) return;
      let journal = {journal: this.new_journal, transactions: this.transactions}
      await this.insertInventoryJournalRequest(journal);
      router.push('/inventoryjournal/list');
    },
    deleteTransaction(item){
      let index = this.transactions.findIndex((trans)=>trans.id==item.id);
      if(index!=-1) this.transactions.splice(index, 1);
    },
    editTransactionDialog(item){
      this.edit_transaction = Object.assign({}, item);
      this.isEditTransaction = true;
    },
    editTransaction(){
      this.isEditTransaction = false;
      let index = this.transactions.findIndex((trans) => trans.id == this.edit_transaction.id);
      let trans = Object.assign({}, this.edit_transaction);
      this.transactions.splice(index, 1, trans);
      this.edit_transaction = {};
    },
    findPriceByQuantity(prices, itemid, qty){
      let price = prices.find(price=> price.itemid==itemid && parseInt(qty)>=price.minqty && parseInt(qty)<=price.maxqty);
      return price;
    },
    insertTransaction(){
      this.add_transaction.id = Math.floor(Math.random() * Math.pow(10, 10));
      this.transactions.push(this.add_transaction);
    },
    insertTransactionTransfer(){
      let trans_inc = Object.assign({}, this.add_transaction, {decreaseQty: 0});
      let trans_dec = Object.assign({}, this.add_transaction, {locationid: this.new_journal.locationid, increaseQty: 0, decreaseQty: trans_inc.increaseQty});
      trans_inc.id = Math.floor(Math.random() * Math.pow(10, 10));
      trans_dec.id = Math.floor(Math.random() * Math.pow(10, 10));
      this.transactions.push(trans_dec);
      this.transactions.push(trans_inc);
    },
    getParams(params){
      let json = {
        journaltype: 'Inventory Journal',
        journalsubtype: 'Inventory Adjustment',
        journaldate:  formatStdDate(params.countdate), 
        locationid:params.locationid, 
        journalname: `Inventory Count #${params.countnum} Adjustment`,
      }
      this.new_journal = Object.assign({}, json);
      if(params.transactions.length>0) this.isCount = true;
      params.transactions.forEach((i)=>{
        let item = this.items.find(item=>item._id == i.itemid);
        let itemstart = this.getInventory(i.itemid);
        let itemadjust = parseFloat((i.itemquantity-itemstart).toFixed(2));
        let itemending = itemstart + itemadjust;
        let increaseQty;
        let decreaseQty;
        if(itemadjust>=1){
          increaseQty = parseFloat(Math.abs(itemadjust).toFixed(2));
          decreaseQty = 0;
        }
        else if(itemadjust<=-1){
          increaseQty = 0;
          decreaseQty = parseFloat(Math.abs(itemadjust).toFixed(2));
        }
        else {
          itemadjust = 0;
          increaseQty = 0;
          decreaseQty = 0;
        }
        
        let json = {
          itemid: i.itemid,
          brandid: item!=null ? item.brandid : null,
          itemname: i.itemname,
          itemimage: i.itemimage,
          itemstart: itemstart,
          itemadjust: itemadjust,
          increaseQty: increaseQty,
          decreaseQty: decreaseQty,
          itemending: itemending,
          itemcost: i.itemcost,
          locationid: i.locationid,
        }
        this.transactions.push(json);
      });
      
    },
    getInventory(itemid){
      if(this.data_inventory==null || this.data_inventory.transactions==null) return 0;
      let find = this.inventory.transactions.find(i=>i.itemid==itemid);
      if(find==null) return 0;
      let result = find.itemquantity;
      if(result==null) return 0;
      return result;
    },
    onChangeItem(itemid){
      let item = this.items.find(item=>item._id == itemid);
      let pricelist = this.pricelists.find(i=>i.pricelisttype=='Purchasing');
      if(!this.add_transaction.itemquantity) this.add_transaction.itemquantity = 1;
      let cost = this.findPriceByQuantity(pricelist.prices, item._id, this.add_transaction.itemquantity);
      let update = {
        itemid: item._id,
        itemimage: item.itemimage, 
        itemname: item.itemname,
        itemquantity: this.add_transaction.itemquantity,
        itemcost: cost!=null ? cost.listprice : 0,
      }
      this.add_transaction = Object.assign({}, this.add_transaction, update);
    },
    onChangeItemEdit(itemid){
      let item = this.items.find(item=>item._id == itemid);
      let pricelist = this.pricelists.find(i=>i.pricelisttype=='Purchasing');
      if(!this.edit_transaction.itemquantity) this.edit_transaction.itemquantity = 1;
      let cost = this.findPriceByQuantity(pricelist.prices, item._id, this.edit_transaction.itemquantity);
      let update = {
        itemid: item._id,
        itemimage: item.itemimage, 
        itemname: item.itemname,
        itemquantity: this.edit_transaction.itemquantity,
        itemcost: cost!=null ? cost.listprice : 0,
      }
      this.edit_transaction = Object.assign({}, this.edit_transaction, update);
    },
  },

  async created () {
    let params = this.$route.params;

    if(this.brands.length==0) await this.getBrandsRequest();
    if(this.items.length==0) await this.getItemsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.pricelists.length==0) await this.getPriceListsRequest();
    this.data_inventory = await this.findInventoryRequest({enddate: params.countdate, locationid: params.locationid});

    if(params!=null){
      this.getParams(params); 
    }
    
    
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
